import { db } from '../firebase/config';
import { collection, query, where, getDocs, orderBy, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';

// Get all products from purchases (inventory)
export const getInventory = async (userId) => {
  try {
    const purchasesRef = collection(db, 'purchases');
    const q = query(
      purchasesRef,
      where('userId', '==', userId),
      where('productName', '!=', ''),
      orderBy('productName'),
      orderBy('purchaseDate', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    const inventory = [];
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.productName && data.imeiNumber) {
        inventory.push({
          id: doc.id,
          ...data,
          purchaseId: doc.id,
          purchaseDate: data.purchaseDate?.toDate() // Convert Firestore Timestamp to Date
        });
      }
    });
    
    return inventory;
  } catch (error) {
    console.error('Error fetching inventory:', error);
    throw error;
  }
};

// Get available products (not sold yet)
export const getAvailableProducts = async (userId) => {
  try {
    const inventory = await getInventory(userId);
    const salesRef = collection(db, 'sales');
    const q = query(
      salesRef,
      where('userId', '==', userId),
      where('imeiNumber', '!=', '')
    );
    
    const salesSnapshot = await getDocs(q);
    const soldImeis = new Set();
    
    salesSnapshot.forEach((doc) => {
      const sale = doc.data();
      if (sale.imeiNumber) {
        soldImeis.add(sale.imeiNumber);
      }
    });
    
    // Filter out sold products
    const availableProducts = inventory.filter(product => 
      !soldImeis.has(product.imeiNumber)
    );
    
    return availableProducts;
  } catch (error) {
    console.error('Error fetching available products:', error);
    throw error;
  }
};

// Mark product as sold
export const markProductAsSold = async (productId, saleId) => {
  try {
    const productRef = doc(db, 'purchases', productId);
    await updateDoc(productRef, {
      isSold: true,
      saleId: saleId,
      soldAt: new Date()
    });
  } catch (error) {
    console.error('Error marking product as sold:', error);
    throw error;
  }
};
